export default "__VITE_ASSET__e049758b__"